import Charts from "./Charts";
import FnHead from "./FnHead";

const componetsJson = [
  {
    value: "Charts",
    label: "图表"
  },
  {
    value: "FnHead",
    label: "通用头部文件"
  }
];
export default componetsJson;
// debugger
export { Charts, FnHead };
